<template>
  <div class="books-setting-selector">
    <span class="books-title">选择花城书房</span>
    <draggable v-if="Array.isArray($$FormData.flowers)" v-bind="{ sort: true }" :list="$$FormData.flowers"
      prevent-on-filter animation="200" filter=".ignore-drag" class="book-list">
      <transition-group>
        <div v-for="item in $$FormData.flowers" :key="item.id" class="item-book">
          <img :src="getCoverImage(item)" :alt="item.name" class="book-img" />
          <i class="ri-close-circle-fill del-icon" @click="handleDeleteBook(item)"></i>
        </div>
        <div class="item-book add ignore-drag" key="add-goods" @click="handleAddBook">
          <i class="ri-add-line"></i>
        </div>
      </transition-group>
    </draggable>
    <en-book-flower-house-picker
      :show="book_picker_show"
      :request="$$Request"
      :default-ids="selectedIds"
      @confirm="handleBookPickerConfirm"
      @closed="book_picker_show = false"
    />
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  name: 'BookFlowerHouseSelector',
  components: { Draggable },
  data() {
    return {
      book_picker_show: false
    }
  },
  computed: {
    selectedIds() {
      const flowers = this.$$FormData.flowers || []
      return flowers.map(item => item.id)
    }
  },
  methods: {
    handleAddBook() {
      this.book_picker_show = true
    },
    handleDeleteBook(item) {
      const index = this.$$FormData.flowers.findIndex(_item => _item.id === item.id)
      this.$$FormData.flowers.splice(index, 1)
    },
    handleBookPickerConfirm(items) {
      items = JSON.parse(JSON.stringify(items))
      this.$$FormData.flowers = items.map(item => {
        delete item.creator
        delete item.updater
        delete item.intro
        return item
      })
    },
    getCoverImage(item) {
      const pic_url = item.pic_url || ''
      return pic_url.split(',')[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.books-setting-selector {
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  background-color: #ffffff;

  .books-title {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #969799;
    line-height: 18px;
    white-space: nowrap;
  }

  .book-list {
    padding: 12px 16px;
    background-color: #f7f8fa;
    box-sizing: border-box;

    &>span {
      display: flex;
      flex-wrap: wrap;
    }

    .item-book {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      padding: 0;
      margin: 5px 10px 5px 0;
      border: none;
      box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
      color: #155bd4;
      font-size: 14px;
      background-color: #ffffff;
      border-radius: 2px;
      cursor: move;

      &.add {
        cursor: pointer;
      }

      &:hover {
        .del-icon {
          display: block;
        }

        &:not(.add)::after {
          display: block;
        }
      }

      &::after {
        display: none;
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #155bd4;
        border-radius: 2px;
        z-index: 1;
        pointer-events: none;
      }

      .book-img {
        display: block;
        width: 100%;
        height: 100%;
        margin: 0;
        overflow: hidden;
      }

      .del-icon {
        display: none;
        position: absolute;
        z-index: 2;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        color: #bbbbbb;
        font-size: 20px;
        background-color: #ffffff;
        line-height: normal;
        cursor: pointer;
      }
    }
  }
}
</style>
